module.exports = __webpack_public_path__ + "media/bootstrap-icons/suit-diamond-fill-0fab34ac.svg";